"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTypeNamesToQuilt = exports.getCustomQuiltId = exports.isCustomQuiltId = exports.toQuiltInput = exports.toQuiltContainerInput = exports.toQuiltComponent = void 0;
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const ObjectHelper_1 = require("../objects/ObjectHelper");
function toQuiltSection(section) {
    return {
        bgColor: section.bgColor,
        bgImage: section.bgImage
            ? {
                assetName: section.bgImage.assetName,
                backgroundSize: section.bgImage.backgroundSize,
                backgroundRepeat: section.bgImage.backgroundRepeat,
                backgroundPosition: section.bgImage.backgroundPosition,
                lastModified: section.bgImage.lastModified
            }
            : null,
        disableSpacing: section.disableSpacing,
        edgeToEdgeDisplay: section.edgeToEdgeDisplay,
        sectionEditLevel: section.sectionEditLevel,
        fullHeight: section.fullHeight,
        id: section.id,
        layout: section.layout,
        showBorder: section.showBorder,
        showDescription: section.showDescription,
        showTitle: section.showTitle,
        textColor: section.textColor,
        textPosition: section.textPosition
    };
}
function toQuiltComponent(component) {
    return {
        id: component.id,
        className: component.className,
        props: component.props,
        wrapper: component.wrapper
            ? {
                element: component.wrapper.element,
                className: component.wrapper.className
            }
            : null
    };
}
exports.toQuiltComponent = toQuiltComponent;
/**
 * converts array of quilt sections to quilt section input
 * @param items quilt section array
 */
function toQuiltSectionInputs(items) {
    return items.map(section => {
        switch (section.layout) {
            case graphql_schema_types_1.SectionLayoutType.OneColumn: {
                return {
                    oneColumn: Object.assign(Object.assign({}, toQuiltSection(section)), { columnMap: {
                            main: section.columnMap.main.map(component => toQuiltComponent(component))
                        } })
                };
            }
            case graphql_schema_types_1.SectionLayoutType.TwoColumn: {
                return {
                    twoColumn: Object.assign(Object.assign({}, toQuiltSection(section)), { columnMap: {
                            column1: section.columnMap.column1.map(component => toQuiltComponent(component)),
                            column2: section.columnMap.column2.map(component => toQuiltComponent(component))
                        } })
                };
            }
            case graphql_schema_types_1.SectionLayoutType.ThreeColumn: {
                return {
                    threeColumn: Object.assign(Object.assign({}, toQuiltSection(section)), { columnMap: {
                            column1: section.columnMap.column1.map(component => toQuiltComponent(component)),
                            column2: section.columnMap.column2.map(component => toQuiltComponent(component)),
                            column3: section.columnMap.column3.map(component => toQuiltComponent(component))
                        } })
                };
            }
            case graphql_schema_types_1.SectionLayoutType.MainSide: {
                return {
                    mainSide: Object.assign(Object.assign({}, toQuiltSection(section)), { columnMap: {
                            main: section.columnMap.main.map(component => toQuiltComponent(component)),
                            side: section.columnMap.side.map(component => toQuiltComponent(component))
                        } })
                };
            }
            case graphql_schema_types_1.SectionLayoutType.SideMain: {
                return {
                    sideMain: Object.assign(Object.assign({}, toQuiltSection(section)), { columnMap: {
                            side: section.columnMap.side.map(component => toQuiltComponent(component)),
                            main: section.columnMap.main.map(component => toQuiltComponent(component))
                        } })
                };
            }
            default: {
                return {};
            }
        }
    });
}
/**
 * converts an instance of quilt to QuiltWithContainerInput
 * @param quilt
 */
function toQuiltContainerInput(quilt) {
    const { container } = quilt;
    const containerClone = (0, ObjectHelper_1.deepClone)(container);
    const _a = (0, ObjectHelper_1.cleanTypenameField)(containerClone), { items } = _a, restContainerProps = __rest(_a, ["items"]);
    return {
        id: quilt.id,
        container: Object.assign(Object.assign({}, restContainerProps), { items: toQuiltSectionInputs(items) })
    };
}
exports.toQuiltContainerInput = toQuiltContainerInput;
function toQuiltInput(quilt) {
    const quiltToCopy = (0, ObjectHelper_1.deepClone)(quilt);
    const quiltInput = {
        id: quiltToCopy.id,
        items: []
    };
    quiltToCopy.items.forEach(quiltItem => {
        var _a, _b;
        switch (quiltItem.type) {
            case graphql_schema_types_1.QuiltItemType.Header: {
                quiltInput.items.push({
                    header: {
                        id: quiltItem.id,
                        type: quiltItem.type,
                        props: quiltItem.props,
                        className: quiltItem.className
                    }
                });
                break;
            }
            case graphql_schema_types_1.QuiltItemType.List: {
                quiltInput.items.push({
                    list: {
                        id: quiltItem.id,
                        type: quiltItem.type,
                        wrapper: {
                            element: (_a = quiltItem.wrapper) === null || _a === void 0 ? void 0 : _a.element,
                            className: (_b = quiltItem.wrapper) === null || _b === void 0 ? void 0 : _b.className
                        },
                        items: toQuiltSectionInputs(quiltItem.items)
                    }
                });
                break;
            }
            case graphql_schema_types_1.QuiltItemType.Footer: {
                quiltInput.items.push({
                    footer: {
                        id: quiltItem.id,
                        type: quiltItem.type,
                        props: quiltItem.props,
                        className: quiltItem.className
                    }
                });
                break;
            }
            default: {
                break;
            }
        }
    });
    return quiltInput;
}
exports.toQuiltInput = toQuiltInput;
const CUSTOM_QUILT_PREFIX = 'C.';
/**
 * Is this a custom quilt?
 * @param quiltId the id of the quilt.
 */
function isCustomQuiltId(quiltId) {
    return quiltId === null || quiltId === void 0 ? void 0 : quiltId.startsWith(CUSTOM_QUILT_PREFIX);
}
exports.isCustomQuiltId = isCustomQuiltId;
/**
 * Helper function for formatting a custom quilt id.
 * @param customPageId
 */
function getCustomQuiltId(customPageId) {
    return `${CUSTOM_QUILT_PREFIX}${customPageId}`;
}
exports.getCustomQuiltId = getCustomQuiltId;
/**
 * Adds GraphQL _typename fields to quilt elements.
 * @param quilt
 */
function addTypeNamesToQuilt(quilt) {
    var _a, _b, _c, _d, _e;
    const quiltTypeNames = (0, ObjectHelper_1.deepClone)(Object.assign(Object.assign({}, quilt), { __typename: 'Quilt' }));
    function addTypesToQuiltComponents(quiltComponents) {
        quiltComponents === null || quiltComponents === void 0 ? void 0 : quiltComponents.forEach(item => {
            if (item) {
                item.__typename = 'QuiltComponent';
                if (item.wrapper) {
                    item.wrapper.__typename = 'ElementWrapper';
                }
            }
        });
    }
    function addTypesToSectionBackground(quiltSection) {
        if (quiltSection === null || quiltSection === void 0 ? void 0 : quiltSection.bgImage) {
            quiltSection.bgImage.__typename = 'BackgroundImageProps';
        }
    }
    function addTypeNameToQuiltSection(sectionItem) {
        if (sectionItem) {
            addTypesToSectionBackground(sectionItem);
            switch (sectionItem.layout) {
                case graphql_schema_types_1.SectionLayoutType.OneColumn: {
                    const oneColumnSection = sectionItem;
                    oneColumnSection.__typename = 'OneColumnQuiltSection';
                    oneColumnSection.columnMap.__typename = 'OneSectionColumns';
                    addTypesToQuiltComponents(oneColumnSection.columnMap.main);
                    break;
                }
                case graphql_schema_types_1.SectionLayoutType.TwoColumn: {
                    const twoColumnSection = sectionItem;
                    twoColumnSection.__typename = 'TwoColumnQuiltSection';
                    twoColumnSection.columnMap.__typename = 'TwoSectionColumns';
                    addTypesToQuiltComponents(twoColumnSection.columnMap.column1);
                    addTypesToQuiltComponents(twoColumnSection.columnMap.column2);
                    break;
                }
                case graphql_schema_types_1.SectionLayoutType.ThreeColumn: {
                    const threeColumnSection = sectionItem;
                    threeColumnSection.__typename = 'ThreeColumnQuiltSection';
                    threeColumnSection.columnMap.__typename = 'ThreeSectionColumns';
                    addTypesToQuiltComponents(threeColumnSection.columnMap.column1);
                    addTypesToQuiltComponents(threeColumnSection.columnMap.column2);
                    addTypesToQuiltComponents(threeColumnSection.columnMap.column3);
                    break;
                }
                case graphql_schema_types_1.SectionLayoutType.MainSide: {
                    const mainSideSection = sectionItem;
                    mainSideSection.__typename = 'MainSideQuiltSection';
                    mainSideSection.columnMap.__typename = 'MainSideSectionColumns';
                    addTypesToQuiltComponents(mainSideSection.columnMap.main);
                    addTypesToQuiltComponents(mainSideSection.columnMap.side);
                    break;
                }
                case graphql_schema_types_1.SectionLayoutType.SideMain: {
                    const sideMainSection = sectionItem;
                    sideMainSection.__typename = 'SideMainQuiltSection';
                    sideMainSection.columnMap.__typename = 'MainSideSectionColumns';
                    addTypesToQuiltComponents(sideMainSection.columnMap.side);
                    addTypesToQuiltComponents(sideMainSection.columnMap.main);
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }
    function addTypeNameToQuiltContainerSectionProps(containerSectionProps) {
        if (containerSectionProps) {
            containerSectionProps.__typename = 'QuiltContainerSectionProps';
            if (containerSectionProps === null || containerSectionProps === void 0 ? void 0 : containerSectionProps.backgroundImageProps) {
                containerSectionProps.backgroundImageProps.__typename = 'BackgroundImageProps';
            }
        }
    }
    (_a = quiltTypeNames === null || quiltTypeNames === void 0 ? void 0 : quiltTypeNames.items) === null || _a === void 0 ? void 0 : _a.forEach(quiltSection => {
        var _a;
        if (quiltSection) {
            switch (quiltSection.type) {
                case graphql_schema_types_1.QuiltItemType.Header: {
                    quiltSection.__typename = 'QuiltHeader';
                    break;
                }
                case graphql_schema_types_1.QuiltItemType.List: {
                    quiltSection.__typename = 'QuiltList';
                    (_a = quiltSection.items) === null || _a === void 0 ? void 0 : _a.forEach(sectionItem => {
                        addTypeNameToQuiltSection(sectionItem);
                    });
                    if (quiltSection.wrapper) {
                        quiltSection.wrapper.__typename = 'ElementWrapper';
                    }
                    break;
                }
                case graphql_schema_types_1.QuiltItemType.Footer: {
                    quiltSection.__typename = 'QuiltFooter';
                    break;
                }
                default: {
                    break;
                }
            }
        }
    });
    if (quiltTypeNames === null || quiltTypeNames === void 0 ? void 0 : quiltTypeNames.container) {
        quiltTypeNames.container.__typename = 'QuiltContainer';
        (_c = (_b = quiltTypeNames.container) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.forEach(quiltSection => addTypeNameToQuiltSection(quiltSection));
    }
    addTypeNameToQuiltContainerSectionProps((_d = quiltTypeNames === null || quiltTypeNames === void 0 ? void 0 : quiltTypeNames.container) === null || _d === void 0 ? void 0 : _d.headerProps);
    addTypeNameToQuiltContainerSectionProps((_e = quiltTypeNames === null || quiltTypeNames === void 0 ? void 0 : quiltTypeNames.container) === null || _e === void 0 ? void 0 : _e.footerProps);
    return quiltTypeNames;
}
exports.addTypeNamesToQuilt = addTypeNamesToQuilt;
//# sourceMappingURL=QuiltHelper.js.map